<section class="funfacts-area pb-70">
  <div class="container">
    <div class="row">
      @for (Funfacts of singleFunfactsBox; track Funfacts) {
        <div class="col-lg-3 col-sm-6 col-6 col-md-3">
          <div class="single-funfacts-box">
            <div class="icon">
              <img [src]="Funfacts.icon" [alt]="Funfacts.subTitle + ' statistic icon'">
            </div>
            <h3>{{Funfacts.title}}</h3>
            <p>{{Funfacts.subTitle}}</p>
          </div>
        </div>
      }
    </div>
  </div>
</section>